import * as Sentry from '@sentry/react';

import theme from 'styles/theme/theme';

Sentry.init({
  dsn: 'https://43f5a9c8019ef3ef52e999a7d926804b@sentry.artcodix.com/3',
  environment: import.meta.env.VITE_SENTRY_ENV || import.meta.env.VITE_NODE_ENV,
  integrations: [
    Sentry.browserTracingIntegration({ enableInp: true }),
    Sentry.browserProfilingIntegration(),
    Sentry.replayIntegration(),
    Sentry.replayCanvasIntegration(),
    Sentry.feedbackIntegration({
      // Additional SDK configuration goes in here, for example:
      autoInject: false,
      colorScheme: 'light',
      showBranding: false,
      showEmail: false,
      triggerLabel: 'Feedback',
      formTitle: 'Give Feedback',
      submitButtonLabel: 'Send Feedback',
      messagePlaceholder: "What's your feedback?",
      enableScreenshot: false,
      themeLight: { accentBackground: theme('de').palette.primary.main }
    })
  ],
  // Performance Monitoring
  tracesSampleRate: 0.1, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    'localhost',
    /dashboard\.th-rosenheim\.de$/,
    /staging\.dashboard\.th-rosenheim\.de$/,
    /dev\.dashboard\.th-rosenheim\.de$/
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  beforeBreadcrumb(breadcrumb, hint) {
    if (breadcrumb.category === 'console') {
      return null;
    }
    return breadcrumb;
  },
  // Set profilesSampleRate to 1.0 to profile every transaction.
  // Since profilesSampleRate is relative to tracesSampleRate,
  // the final profiling rate can be computed as tracesSampleRate * profilesSampleRate
  // For example, a tracesSampleRate of 0.5 and profilesSampleRate of 0.5 would
  // results in 25% of transactions being profiled (0.5*0.5=0.25)
  profilesSampleRate: 1.0
});
